.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25em;
  padding: 0 var(--space-1);
  border: none;
  border-radius: var(--radius-sm);
  background: var(--color-surface-hover);
  color: var(--color-text-muted);
  font: inherit;
  font-size: var(--font-size-xs);
  line-height: 1.25rem;
  white-space: nowrap;
}

.action {
  cursor: pointer;
}

.action:hover {
  filter: brightness(1.08);
  outline: 1px solid var(--color-border);
}

/* Due today: yellow. */
.today {
  background: var(--color-warning);
  color: var(--color-warning-contrast);
  font-weight: 600;
}

/* Due tomorrow or later: blue. */
.tomorrow,
.later {
  background: var(--color-info);
  color: var(--color-info-contrast);
}

/* Overdue: red (and always with the warning icon + text alternative). */
.overdue {
  background: var(--color-danger);
  color: #fff;
  font-weight: 600;
}

/* A done card keeps its deadline as history, but never looks urgent. */
.done {
  background: transparent;
  color: var(--color-text-muted);
  font-weight: 400;
  text-decoration: line-through;
}
